// 用户token
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN';

// 国际化
export const LOCALE_KEY = 'LOCALE__';

// 用户信息
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';

export const IS_LOCKSCREEN = 'IS_LOCKSCREEN'; // 是否锁屏
export const TABS_ROUTES = 'TABS_ROUTES'; // 标签页

// 用户类别
export const LAST_USER_ROLE = 'LAST_USER_ROLE'; // 上次登录的用户角色
